import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { EstadoHorizontalReserva } from '../interfaces/EstadoHorizontalReservas'
import { EstadoVerticalReservas } from '../interfaces/EstadoVerticalReservas'
import { TransicionesPermitidas } from '../interfaces/TransicionesPermitidas'

interface ReservasState {
  menuId: number
  showDrawelBookingStatus: boolean
  estadosPorReserva: EstadoVerticalReservas[]
  allowedTransitions: TransicionesPermitidas[]
  horizontalStates: EstadoHorizontalReserva[]
  hasUserSearched: boolean
  shouldTriggerSearch: boolean // Flag para coordinar refresh con filtros activos
}

const initialState: ReservasState = {
  menuId: 0,
  showDrawelBookingStatus: false,
  estadosPorReserva: [],
  allowedTransitions: [],
  horizontalStates: [],
  hasUserSearched: false,
  shouldTriggerSearch: false,
}

const reservasSlice = createSlice({
  name: 'reservas',
  initialState,
  reducers: {
    setMenuId(state, action: PayloadAction<{ value: number }>) {
      state.menuId = action.payload.value
    },
    setShowDrawelBookingStatus(
      state,
      action: PayloadAction<{ value: boolean }>,
    ) {
      state.showDrawelBookingStatus = action.payload.value
    },
    setEstadosPorReserva(
      state,
      action: PayloadAction<{ value: EstadoVerticalReservas[] }>,
    ) {
      state.estadosPorReserva = action.payload.value
    },
    setAllowedTransitions(
      state,
      action: PayloadAction<{ value: TransicionesPermitidas[] }>,
    ) {
      state.allowedTransitions = action.payload.value
    },
    setHorizontalStates(
      state,
      action: PayloadAction<{ value: EstadoHorizontalReserva[] }>,
    ) {
      state.horizontalStates = action.payload.value
    },
    setHasUserSearched(state, action: PayloadAction<{ value: boolean }>) {
      state.hasUserSearched = action.payload.value
    },
    setShouldTriggerSearch(state, action: PayloadAction<{ value: boolean }>) {
      state.shouldTriggerSearch = action.payload.value
    },
  },
})

export const {
  setMenuId,
  setShowDrawelBookingStatus,
  setEstadosPorReserva,
  setAllowedTransitions,
  setHorizontalStates,
  setHasUserSearched,
  setShouldTriggerSearch,
} = reservasSlice.actions

const ReservasReducer = reservasSlice.reducer

export default ReservasReducer
